export default __webpack_public_path__ + "static/media/book-shipment.8433d547.svg";